import { toast } from '@/helpers/toast/toast.helper'
import { AxiosResponse } from 'axios'
import { put } from 'redux-saga/effects'
import { updateActiveChatAction, updateGroupAction } from '../../handles'
import { zApiMultiService } from '@/services/api'
import { updateGroup } from '../_http/groups'

export function* updateGroupSaga(action: ReturnType<typeof updateGroupAction.request>) {
  const { activeChat, groupName, groupDescription, groupImage, campaign, callBack } = action.payload
  try {
    const formData = new FormData()
    formData.append('groupId', activeChat.phone)
    groupName && formData.append('groupName', groupName)
    groupDescription && formData.append('groupDescription', groupDescription)
    groupImage && formData.append('imageFile', groupImage)

    const url = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/update-complete-group`
    const updateGroupResponse: AxiosResponse = yield zApiMultiService.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    const updates: Record<string, string> = {}
    if (updateGroupResponse?.data?.nameUpdated) updates.chatName = groupName
    if (updateGroupResponse?.data?.descriptionUpdated) updates.description = groupDescription
    if (updateGroupResponse?.data?.photoUpdated) updates.requesterPhoto = updateGroupResponse.data.imgUrl

    if (Object.keys(updates).length > 0) {
      yield updateGroup(activeChat.id, { ...updates, ownerId: activeChat.ownerId })
      yield put(updateActiveChatAction(updates))
    }

    toast({ type: 'success', message: `Grupo atualizado com sucesso` })
    callBack?.()
    yield put(updateGroupAction.success({ updatedChatData: {} }))
  } catch (error) {
    toast({ type: 'error', message: 'Erro ao atualizar grupo' })
    console.log({ updateGroupSagaError: error })
    yield put(updateGroupAction.failure(error))
  }
}
